
<div
  class="navbar-container"
  [class.example-is-mobile]="mobileQuery.matches"
  *ngIf="isLoggedIn"
>
  <mat-toolbar class="navbar" color="primary">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <a
      class="navbar-brand"
      routerLink="/"
      matTooltip="Home"
      style="margin-top: 2px"
    >
    CHMES
      <!-- <a href="#"
        ><img [src]="logo" width="60" height="50" alt="CHEMS"
        title="CHEMS" class="logo"></a> -->
   
    </a>

    <span class="example-spacer"></span>
    <span class="navbar-spacer"></span>
    <span> </span>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="20px"
    ></div>
   

    <button matTooltip="Help!" (click)="help()"  mat-icon-button >
      <mat-icon  matBadgeColor="warn">help</mat-icon>
    </button>
    
   
  <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
    <span class="user-name" fxShow fxHide.xs> Welcome !! {{ userName }} </span>
    <mat-icon>person</mat-icon>
  </button>
    <mat-menu
      #userMenu="matMenu"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <!-- <a mat-menu-item routerLink="/account/profile">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </a>
      <a mat-menu-item routerLink="/account/change-password">
        <mat-icon>settings</mat-icon>
        <span>Change Password</span>
      </a> -->
      <a mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Log out</span>
      </a>
    </mat-menu>
  </mat-toolbar>

  <mat-sidenav-container class="navbar-sidenav-container" cdkScrollable>
    <mat-sidenav
      #snav
      [opened]="!mobileQuery.matches"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56"
      class="sidenav"
    >
      <mat-nav-list>
        <app-menu-list
          *ngFor="let item of navItems"
          [item]="item"
        ></app-menu-list>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content">
      <div class="progress-bar-container">
      </div>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
